import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import McActions from 'store/redux/mc'
import { Row, Col, Form } from 'reactstrap'
import { translate } from 'react-i18next'
import { pageData } from 'decorators'
import { FG, Button } from 'components'
import { numericRule, rangeValueRule } from 'utils/validation'
// import MOCK_TEMPLATE from 'data/mocks/mc/newGameTemplate.json'
import AdminTemplate from '../../templates/AdminTemplate'
import './NewGame.css'

@connect(
    state => {
        const tmpl = state.mc.newGameTemplate
        return {
            isLoading: state.global.loading,
            initialValues: {
                numHumans: tmpl.players.humans.default,
                numPlayers: tmpl.players.total.default,
                seasons: tmpl.seasons.default,
                races: tmpl.races.default,
                timePerPhase: tmpl.timePerPhase.default,
                budgetPerSeason: tmpl.budgetPerSeason.default,
            },
            maxValues: {
                numHumans: tmpl.players.humans.max,
                numPlayers: tmpl.players.total.max,
                seasons: tmpl.seasons.max,
                races: tmpl.races.max,
                timePerPhase: tmpl.timePerPhase.max,
                budgetPerSeason: tmpl.budgetPerSeason.max,
            }
        }
    },
    {
        save: McActions.newGameSaveStep1
    }
)
@reduxForm({ form: 'mcNewGameStep1' })
@pageData({ title: 'New Game (1/3)' })
@translate()
export class NewGameStep1 extends PureComponent {
    componentWillMount() {
        const { maxValues, t } = this.props
        this.numericRule = numericRule(t)
        this.rangeValueRules = {
            numHumans: rangeValueRule(1, maxValues.numHumans, t),
            numPlayers: rangeValueRule(1, maxValues.numPlayers, t),
            seasons: rangeValueRule(1, maxValues.seasons, t),
            races: rangeValueRule(1, maxValues.races, t),
            timePerPhase: rangeValueRule(1, maxValues.timePerPhase, t),
            budgetPerSeason: rangeValueRule(1, maxValues.budgetPerSeason, t),
        }
    }
    onSubmit = ({ numHumans, numPlayers, seasons, races, timePerPhase, budgetPerSeason }) => this.props.save({
        players: {
            humans: numHumans,
            total: numPlayers
        },
        seasons,
        races,
        timePerPhase,
        budgetPerSeason
    })

    renderNumberInput = id => {
        const { maxValues, t } = this.props
        return (
            <FG.Text
                type="number"
                id={id}
                name={id}
                label={t(`mc.newGame.step1.${id}`)}
                required
                min={1}
                max={maxValues[id]}
                autoComplete="off"
                validate={[this.numericRule, this.rangeValueRules[id]]}
            />
        )
    }

    render() {
        const { handleSubmit, submitting, t, isLoading } = this.props

        return (
            <AdminTemplate className="NewGame Step1 px-5" backRoute="/mc">
                <h1 dangerouslySetInnerHTML={{ __html: t('mc.newGame.step1.title') }} />
                <Form onSubmit={handleSubmit(this.onSubmit)} className="pb-5">
                    <h2>{t('mc.newGame.step1.subtitle')}</h2>
                    <Row>
                        <Col>
                            <legend>{t('mc.newGame.step1.section.players')}</legend>
                            {this.renderNumberInput('numHumans')}
                            {this.renderNumberInput('numPlayers')}
                        </Col>

                        <Col>
                            <legend>{t('mc.newGame.step1.section.seasonsAndRaces')}</legend>
                            {this.renderNumberInput('seasons')}
                            {this.renderNumberInput('races')}
                            {this.renderNumberInput('budgetPerSeason')}
                        </Col>

                        <Col>
                            <legend>{t('mc.newGame.step1.section.phase')}</legend>
                            {this.renderNumberInput('timePerPhase')}
                        </Col>
                    </Row>

                    <div className="Action-Btns">
                        <Button type="submit" color="primary" loading={isLoading} disabled={submitting}>
                            {t('mc.newGame.step1.nextBtn')}
                        </Button>
                    </div>
                </Form>
            </AdminTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/MC/NewGame/NewGameStep1.js